// Loading placeholder for a recipe card. Some cards get an image block on
// top (like recipes with photos) so the skeleton grid has varied heights —
// matching the real masonry layout instead of a uniform grid.
const RecipeCardSkeleton = ({ withImage = false, className = '', style = {} }) => (
  <div
    className={`rounded-lg overflow-hidden ${className}`}
    style={{ backgroundColor: '#F3EEE4', ...style }}
  >
    {withImage && (
      // Placeholder image: slightly darker cream than the card body
      <div style={{ backgroundColor: '#E5DECE', height: '160px', width: '100%' }} />
    )}
    <div className="p-4">
      {/* Category tag skeleton */}
      <div className="h-6 w-16 rounded-full mb-3" style={{ backgroundColor: '#D6D0C2' }} />
      {/* Title skeleton */}
      <div className="h-8 w-full rounded mb-2" style={{ backgroundColor: '#D6D0C2' }} />
      <div className="h-8 w-3/4 rounded mb-3" style={{ backgroundColor: '#D6D0C2' }} />
      {/* Creator skeleton */}
      <div className="h-4 w-24 rounded" style={{ backgroundColor: '#D6D0C2' }} />
    </div>
  </div>
);

export default RecipeCardSkeleton;
